import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserPosts,
  fetchTaskerFeed,
  deleteJobPost,
  viewJobPost,
  createJobPost,
  editJobPost,
  getSingleUserJobPost,
  fetchAllJobs,
} from "../thunks/jobPostThunks";

const jobPostSlice = createSlice({
  name: "jobPost",
  initialState: {
    // user job posts state
    myPosts: {
      posts: [],
      pagination: {},
    },

    allJobPosts: {
      posts: [],
      pagination: {},
    },
    // tasker feed state
    taskerFeed: {
      jobPost: {},
      matchingJobPosts:[],
    },
  
  },
  extraReducers: (builder) => {
    // fetch user job posts
    builder.addCase(fetchUserPosts.fulfilled, (state, action) => {
      state.myPosts.posts = action.payload.data?.data || [];
      state.myPosts.pagination = action.payload.data?.pagination || {};
    });

    // fetch tasker feed
    builder.addCase(fetchTaskerFeed.fulfilled, (state, action) => {
      const responseData = action.payload?.data?.data?.[0] || {};
      
      state.taskerFeed.jobPost = responseData.jobPost?.[0] || {};
      state.taskerFeed.matchingJobPosts = responseData.metaData || [];
    });

    // delete job post
    builder.addCase(deleteJobPost.fulfilled, (state, action) => {
      //console.log("delete job post fulfilled");
    });

    // view job post
    builder.addCase(viewJobPost.fulfilled, (state, action) => {
      //console.log("view job post fulfilled");
    });

    // create job post
    builder.addCase(createJobPost.fulfilled, (state, action) => {
      //console.log("create Job Post Thunk trggered");
    });

    // edit job post
    builder.addCase(editJobPost.fulfilled, (state, action) => {
      //console.log("edit job post fulfilled");
    });

    // get user single job post
    builder.addCase(getSingleUserJobPost.fulfilled, (state, action) => {
      //console.log("get single user job post fulfilled");
    });

    // get all jobs
    builder.addCase(fetchAllJobs.fulfilled, (state, action) => {
      //console.log("Fetched Data in Slice:", action.payload); // Debugging

      state.allJobPosts.posts = action.payload?.data?.data || []; // Corrected data mapping
      state.allJobPosts.pagination = action.payload?.data?.pagination || {};
    });
  },
});

export default jobPostSlice.reducer;
